import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
import { ADD_SLIDE_AUTH_TOKEN, BASIC_AUTH_HEADER, TERMS_AND_COND_HEADER } from '../framework/constants/app';
class WpAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "addSlide", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                const headers = {
                    Authorization: `Basic ${ADD_SLIDE_AUTH_TOKEN}`
                };
                return this.request('post', 'add-slide', data, headers);
            }
        });
        Object.defineProperty(this, "getTermsAndCond", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const headers = process.env.NODE_ENV === 'development' ? BASIC_AUTH_HEADER : TERMS_AND_COND_HEADER;
                return this.request('get', 'pages/43', {}, headers);
            }
        });
        this.setConfig(config);
    }
}
export default new WpAPI({
    baseURL: config.WpAPI.url
});
